import React from 'react';
import Routes from './components/router/Routes';

function App() {
  return (
    <Routes />
  );
}

export default App;
